import React from "react";
export default class HistoryModal extends React.Component {
  render() {
    const { Bs, _icon, SIZE, VARIANT, _placeholder } = this.props;
    return (
      <Bs
        modal
        show={this.props.history.show}
        onHide={this.props.onHide}
        keyboard={false}
        backdrop="static"
        centered
        size={SIZE.LG}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Bs modalheader closeButton>
          Historie komunikace pro zakázku č.:{" "}
          {this.props.history?.items[0]?.docNo}
        </Bs>
        <Bs modalbody>
          {this.props.history.items.length === 0 && <_placeholder />}
          {this.props.history.items && (
            <>
              {this.props.history.items.map((e) => (
                <Bs row className="mb-2">
                  <Bs card bg={VARIANT.UNI}>
                    <Bs cardbody>
                      <Bs row>
                        <Bs col xs={1}>
                          {e.seqNo}
                        </Bs>
                        <Bs col xs={2}>
                          {e.status}
                        </Bs>
                        <Bs col xs={2}>
                          {e.reason}
                        </Bs>
                        <Bs col xs={2}>
                          {new Date(e.dateCreate).toLocaleString()}
                        </Bs>
                        <Bs col xs={3} className="o-el" data-tip={e.response}>
                          {e.response}
                        </Bs>
                        <Bs col xs={2}>
                          <Bs
                            button
                            variant={VARIANT.TRANSPARENT}
                            size={SIZE.SM}
                            className="me-2"
                            data-tip={"Zobrazit odeslaný požadavek"}
                            onClick={() => {
                              let blob = new Blob([e.reqXml], {
                                type: "text/xml",
                              });
                              let url = URL.createObjectURL(blob);
                              window.open(url,"_blank");
                              URL.revokeObjectURL(url);
                            }}
                          >
                            <_icon faupload className="fs-20 c-gray " />
                          </Bs>
                          <Bs
                            button
                            variant={VARIANT.TRANSPARENT}
                            size={SIZE.SM}
                            data-tip={"Zobrazit přijatý výsledek"}
                            onClick={() => {
                              let blob = new Blob([e.resXml], {
                                type: "text/xml",
                              });
                              let url = URL.createObjectURL(blob);
                              window.open(url,"_blank");
                              URL.revokeObjectURL(url);
                            }}
                          >
                            <_icon fadownload className="fs-20 c-gray" />
                          </Bs>
                        </Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              ))}
            </>
          )}
        </Bs>
      </Bs>
    );
  }
}
